import dayjs from 'dayjs';
import React from 'react'
import { Table } from 'react-bootstrap';
import styled from 'styled-components'
import writeXlsxFile from 'write-excel-file';
import { axiosInstance } from '../../../utils/axios';
import { periods } from '../../purchase/common';

const INIT_YEAR = 2022;

const Header = styled.div`
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const MyForm = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const ResultSection = styled.div`
  flex: 1;
  margin-top: .5rem;
`

function AccountingSalesReport() {
  const [period, setPeriod] = React.useState("");
  const [year, setYear] = React.useState("");
  const [data, setData] = React.useState<any>(null);
  const [years, setYears] = React.useState<{ value: number, text: string }[]>([]);

  React.useEffect(() => {
    let year = dayjs().year();
    let arrayOfYears = [];
    while (year >= INIT_YEAR) {
      arrayOfYears.push({
        value: year,
        text: year.toString(),
      });
      year--;
    }
    setYears(arrayOfYears);
  }, []);

  async function downloadExcel() {
    try {
      const schema = [
        {
          column: "Fecha",
          type: String,
          value: (sale: any) => sale.fecha
        },
        {
          column: "Tipo de documento",
          type: String,
          value: (sale: any) => sale.tipo
        },
        {
          column: "Serie",
          type: String,
          value: (sale: any) => sale.serie
        },
        {
          column: 'Numero',
          type: String,
          value: (sale: any) => sale.numero
        },
        {
          column: 'Cliente',
          type: String,
          value: (sale: any) => sale.cliente
        },
        {
          column: 'Sub Total',
          type: Number,
          value: (sale: any) => Number(sale.subTotal)
        },
        {
          column: 'IGV',
          type: Number,
          value: (sale: any) => Number(sale.igv)
        },
        {
          column: 'Total',
          type: Number,
          value: (sale: any) => Number(sale.total)
        },
        {
          column: 'Anulado',
          type: String,
          value: (sale: any) => sale.anulado ? 'Anulado' : "-"
        },
      ];
      return await writeXlsxFile(data, { schema, fileName: `Ventas_${period}.xlsx` });
    } catch (error) {
      console.error(error)
    }
  }

  const handleSelection = async (e: any) => {
    e.preventDefault();
    const res = await axiosInstance.get('/reports/accounting/sales', {
      params: {
        period: Number(period),
        year: Number(year),
      }
    });
    setData(res.data)
  }

  return (
    <>
      <Header>
        <MyForm onSubmit={handleSelection}>
          <h5>Selecciona el periodo contable a consultar: </h5>
          <select name="period" id="period" value={period} onChange={(e) => setPeriod(e.target.value)} required>
            <option value="">Selecciona el periodo</option>
            {periods.map((p, i) => (
              <option key={i} value={p.value}>{p.text}</option>
            ))}
          </select>
          <select id="year" value={year} onChange={(e) => setYear(e.target.value)} required>
            <option value="">Selecciona el año</option>
            {years.map((y, i) => (
              <option key={i} value={y.value}>{y.text}</option>
            ))}
          </select>
          <button className='btn btn-primary' type='submit'>Cargar datos</button>
        </MyForm>
        {data && data.length > 0 && <button className='btn btn-success' onClick={downloadExcel}>Descargar reporte</button>}
      </Header>
      {data &&
        <ResultSection>
          {data.length === 0 && <h1 style={{ color: 'red' }}>No se registran ventas para este periodo</h1>}
          {data.length > 0 &&
            <Table responsive size="sm">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Tipo de documento</th>
                  <th>Serie</th>
                  <th>Número</th>
                  <th>Cliente</th>
                  <th>Sub Total</th>
                  <th>IGV</th>
                  <th>Total</th>
                  <th>Anulado</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item: any, index: number) => (
                  <tr key={index}>
                    <td>{item.fecha}</td>
                    <td>{item.tipo}</td>
                    <td>{item.serie}</td>
                    <td>{item.numero}</td>
                    <td>{item.cliente}</td>
                    <td>{item.subTotal}</td>
                    <td>{item.igv}</td>
                    <td>{item.total}</td>
                    <td>{item.anulado ? "Anulado" : "-"}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          }
        </ResultSection>
      }
    </>
  )
}

export default AccountingSalesReport